module.exports = __webpack_public_path__ + "img/ivann.36468d7d.png";